// extracted by mini-css-extract-plugin
export default {"welcomeSection":"WelcomeOferta_welcomeSection__f6XBh","welcomeContainer":"WelcomeOferta_welcomeContainer__G7dRh","welcomeText":"WelcomeOferta_welcomeText__HGOlT"};